<template>
  <v-container fluid>
    <!-- <v-navigation-drawer app fixed clipped width="400">
      <template v-slot:prepend :elevation="3">
        <v-list-item>
          <v-list-item-title>{{ $t("search") }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-slot:append :elevation="3">
        <v-divider></v-divider>
        <div class="d-flex pa-4">
          <v-btn color="primary" class="mr-4" @click="filter()">{{
            $t("apply_filter")
          }}</v-btn>
          <v-btn color="primary" @click="clearFilter()">{{
            $t("cancel")
          }}</v-btn>
        </div>
      </template>

      <div class="pa-2">
        <filter-part ref="filterView"> </filter-part>
      </div>
    </v-navigation-drawer> -->
    <div class="main-container" fill-height>
      <v-row class="ma-0 mb-2">
        <v-card class="form-container">
          <v-card-title class="flex justify-space-between">
            <v-btn color="primary" :outlined="selectedIdx != 0" @click="selectIdx(0)">应用程序 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 1" @click="selectIdx(1)">订单 </v-btn>
            <v-btn color="primary" :outlined="selectedIdx != 2" @click="selectIdx(2)">全部 </v-btn>
          </v-card-title>
        </v-card>
      </v-row>
      <entity-view
        :item-schemas="itemSchemas"
        :readonly="readonly"
        :items="items"
        :title="$t('feedback')"
        :pagination="pagination"
        :externalActions="externalActions"
        :options="options"
        @items-refresh="itemsRefresh"
        @item-action="itemAction"
        @page-change="pageChange"
      >
      </entity-view>
    </div>
    <input-dialog></input-dialog>
  </v-container>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import InputDialog from "../components/InputDialog.vue";
// import FilterPart from "./FilterPart.vue";

export default {
  components: { EntityView, InputDialog },
  data: () => ({
    title: "Feedback",
    select: true,
    expendOpen: false,
    readonly: true,
    selectedIdx: 0,
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "id",
        value: "id",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "userName",
        value: "userName",
        type: "string",
      },
      {
        name: "orderId",
        value: "orderId",
        type: "string",
      },
      {
        name: "description",
        value: "description",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "createdAt",
        value: "createdAt",
        type: "datetime",
        hasfilter: true,
        condition: {},
      },
    ],
    items: [],
    externalActions: [],
  }),
  mounted() {
    this.updateSchemaData();
    this.refresh();
  },
  computed: {
    options: function () {
      return {
        dateTimePattern: this.$root.$config.dateTimePattern,
        datePattern: this.$root.$config.datePattern,
        showAction: false,
      };
    },
  },
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
      // this.$refs.filterView.loadSchema(this.itemSchemas);
    },
    refresh() {
      let _this = this;
      let postData = {
        pagination: this.pagination,
        criterias: [],//this.$refs.filterView.getCriterias(),
      };

      if (postData.criterias != undefined) {
        let status = [];
        if (this.selectedIdx == 0) {
          status.push("app");
        } else if (this.selectedIdx == 1) {
          status.push("order");
        }

        status.forEach((s) => {
          postData.criterias.push({
            operator: "=",
            type: "string",
            value: s,
            column: "type",
            condition: "or",
          });
        });
      }

      this.post("/api/feedbacks", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh();
    },
    filter() {
      this.refresh();
    },
    clearFilter() {
      this.$refs.filterView.clear();
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction() {
    },
    selectIdx(idx) {
      this.selectedIdx = idx;
      this.refresh();
    },
  },
};
</script>

<style scoped>
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
 "en": {
  },
  "cn": {
  }
}
</i18n>
